import { Dialog, DialogBackdrop, DialogPanel } from "@headlessui/react";
import ShadowXIcon from "components/Icon/ShadowXIcon";
import SingleView from "./SingleView";

const SingleViewModal = ({
  backgroundColor = "#000000",
  allGifs,
  selectedIndex,
  open,
  setOpen,
  channelSlug,
}) => {
  const gif = allGifs[selectedIndex];

  function closeModal() {
    setOpen(false);
  }
  return (
    // Headless UI v2 owns `open` directly and drives the enter/leave animation
    // via the `transition` prop + `data-[closed]`/`data-[leave]` variants. The
    // v1 `<Transition show={open}>` wrapper must NOT come back: under v2 that
    // legacy path skips `useInertOthers`, so the app behind the modal keeps its
    // place in the accessibility tree and a screen reader can browse straight
    // out of the open lightbox. Guarded by gallery-lightbox-a11y.spec.js.
    <Dialog as="div" open={open} onClose={closeModal} className="relative z-50">
      <DialogBackdrop
        transition
        className="fixed inset-0 bg-black/90 transition duration-300 ease-out data-[closed]:opacity-0 data-[leave]:duration-200 data-[leave]:ease-in"
      />

      <div className="fixed inset-0 overflow-y-auto">
        {/* Close button - fixed position, 10px from top and right */}
        <button
          type="button"
          aria-label="Close"
          className="fixed top-[10px] right-[10px] z-10 bg-transparent"
          onClick={closeModal}
        >
          <ShadowXIcon className="w-11 h-11" aria-hidden="true" />
        </button>

        <div className="flex min-h-full items-start sm:items-center justify-center pt-16 sm:pt-0">
          <DialogPanel
            transition
            className="transform w-full sm:w-auto text-left align-middle transition-all duration-300 ease-out data-[closed]:opacity-0 data-[closed]:scale-95 data-[leave]:duration-200 data-[leave]:ease-in"
          >
            <SingleView
              gif={gif}
              backgroundColor={backgroundColor}
              isModal
              channelSlug={channelSlug}
            />
          </DialogPanel>
        </div>
      </div>
    </Dialog>
  );
};

export default SingleViewModal;
